import { createAction } from 'signin-app/redux/helpers';
const domain = 'NURSERY_GROUP';
export const { action: toggleWhoPicksUp } = createAction(`${domain}/TOGGLE_WHO_PICKS_UP`, () => null);
